import { ArrowRight } from "lucide-react";
import { MEDIA } from "../../data/site";

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden">
      {/* subtle radial light */}
      <div
        aria-hidden
        className="absolute -top-40 -right-40 w-[700px] h-[700px] rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(closest-side, #C5A059, transparent)" }}
      />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-end">
        {/* Left content */}
        <div className="lg:col-span-7 reveal">
          <span className="overline">Bathroom Renovations · Ottawa</span>

          <h1
            data-testid="hero-headline"
            className="font-serif-display mt-6 text-[44px] leading-[1.02] sm:text-6xl md:text-7xl lg:text-[88px] text-[#F5F5F0]"
          >
            Bathrooms,<br />
            <span className="italic text-champagne">measured</span> to the millimetre.
          </h1>

          <p className="mt-8 max-w-xl text-[#A3A3A3] text-base md:text-lg leading-relaxed font-sans-body">
            Cresta Bath & Tile designs and builds calm, gallery-grade bathrooms across the Greater Ottawa Area —
            tub-to-shower conversions, full turn-key renovations, and the kind of large-format tile work people
            stop to photograph.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#estimate"
              data-testid="hero-cta-button"
              className="group inline-flex items-center gap-3 bg-champagne text-[#0A0A0A] text-[12px] tracking-[0.2em] uppercase font-semibold px-7 py-4 rounded-sm hover:bg-[#D4AF37] hover-lift"
            >
              Get a Free Estimate
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#portfolio"
              data-testid="hero-portfolio-link"
              className="text-[13px] tracking-[0.18em] uppercase text-[#F5F5F0]/80 hover:text-champagne underline-grow font-sans-body"
            >
              View Recent Work
            </a>
          </div>

          <div className="mt-14 flex flex-wrap gap-x-10 gap-y-4 text-[12px] tracking-wider text-[#A3A3A3] uppercase font-sans-body">
            <span>Licensed & Insured</span>
            <span className="text-[#262626]">·</span>
            <span>5-Year Workmanship Warranty</span>
            <span className="text-[#262626]">·</span>
            <span>Ottawa-Local Since 2018</span>
          </div>
        </div>

        {/* Right image */}
        <div className="lg:col-span-5 reveal">
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
            <img
              src={MEDIA.hero}
              alt="Premium calacatta marble walk-in shower built by Cresta Bath & Tile"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between text-[11px] tracking-[0.22em] uppercase text-[#F5F5F0]/85 font-sans-body">
              <span>Calacatta Walk-In</span>
              <span className="text-champagne">Kanata · 2025</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
